import COM from './Link'

export default COM
